import WarehouseDesktopRequirement from "./screens/WarehouseDesktopRequirement.vue";
import WarehouseMobileRequirement from "./mobile/screens/WarehouseMobileRequirement.vue";
import WarehouseDesktopInventory from "./screens/WarehouseDesktopInventory.vue";
import WarehouseMobileInventory from "./mobile/screens/WarehouseMobileInventory.vue";
import WarehouseScreenEntry from "./screens/docs/WarehouseScreenEntry.vue";
import WarehouseScreenInvoice from "./screens/docs/WarehouseScreenInvoice.vue";
import WarehouseScreenReturn from "./screens/docs/WarehouseScreenReturn.vue";
import WarehouseScreenWriteOff from "./screens/docs/WarehouseScreenWriteOff.vue";
import WarehouseScreenPurchase from "./screens/docs/WarehouseScreenPurchase.vue";
import WarehouseScreenOffers from "./screens/docs/WarehouseScreenOffers.vue";
import WarehouseScreenStocktaking from "./screens/docs/WarehouseScreenStocktaking.vue";
import WarehouseScreenTransactions from "./screens/docs/WarehouseScreenTransactions.vue";
import WarehouseScreenWarehouses from "./screens/docs/WarehouseScreenWarehouses.vue";

export const DEFAULT_WAREHOUSE_SCREEN = "requirement";

const QUICK_FORWARD = ["today", "tomorrow", "this_week"];
const QUICK_BACK = ["today", "yesterday", "this_week"];

/**
 * Izbori u traci filtera po ekranu (isto što je stara stranica imala po tabu):
 *  warehouse – magacini, view – prikaz jela, shifts – smene, period – "range" (od–do) ili "day" (jedan dan, samo čitanje),
 *  status – status dokumenta, docType – tip dokumenta ("order" | "transaction" | "offer"), grocery – šifra namirnice,
 *  suppliers – dobavljači.
 */
const RANGE = { warehouse: true, period: "range" };

/**
 * Ekrani magacina. `legacy: true` je stari tab u novoj ljusci (isto učitavanje, štampa, Excel i dijalozi);
 * ostali su novi ekrani. Redosled u meniju određuje buildWarehouseMenu.
 * @param {(key: string, params?: object) => string} t
 * @param {{ mobile?: boolean }} [options] mobile: novi ekrani za telefon (kartice); stari tabovi su isti
 */
export const buildWarehouseScreens = (t, { mobile = false } = {}) => ({
  requirement: {
    title: t("warehouse_requirement"),
    icon: "mdi-clipboard-list-outline",
    component: mobile ? WarehouseMobileRequirement : WarehouseDesktopRequirement,
    quick: QUICK_FORWARD,
    filters: { ...RANGE, view: true, shifts: true },
  },
  purchase: {
    title: t("warehouse_ordered"),
    icon: "mdi-cart-arrow-down",
    component: WarehouseScreenPurchase,
    quick: QUICK_BACK,
    filters: { ...RANGE, status: true, docType: "order", suppliers: true },
  },
  offers: {
    title: t("offers_invoices"),
    icon: "mdi-file-document-edit-outline",
    component: WarehouseScreenOffers,
    quick: QUICK_BACK,
    filters: { period: "range", docType: "offer", suppliers: true },
  },
  entry: {
    title: t("warehouse.warehouse_replenishment"),
    icon: "mdi-package-variant-plus",
    component: WarehouseScreenEntry,
    quick: QUICK_BACK,
    filters: { ...RANGE, suppliers: true, grocery: true },
  },
  inventory: {
    title: t("warehouse_inventory"),
    icon: "mdi-archive-outline",
    component: mobile ? WarehouseMobileInventory : WarehouseDesktopInventory,
    filters: { warehouse: true, period: "day" },
  },
  list: {
    title: t("stocktaking"),
    icon: "mdi-clipboard-check-outline",
    component: WarehouseScreenStocktaking,
    quick: QUICK_BACK,
    filters: { ...RANGE },
  },
  invoice: {
    title: t("warehouse_issue"),
    icon: "mdi-receipt-text-arrow-right-outline",
    component: WarehouseScreenInvoice,
    quick: QUICK_BACK,
    filters: { ...RANGE },
  },
  return: {
    title: t("warehouse_return"),
    icon: "mdi-backup-restore",
    component: WarehouseScreenReturn,
    quick: QUICK_BACK,
    filters: { ...RANGE },
  },
  writeOff: {
    title: t("write_off"),
    icon: "mdi-delete-sweep-outline",
    component: WarehouseScreenWriteOff,
    quick: QUICK_BACK,
    filters: { ...RANGE },
  },
  transaction: {
    title: t("transactions"),
    icon: "mdi-history",
    component: WarehouseScreenTransactions,
    quick: QUICK_BACK,
    filters: { ...RANGE, docType: "transaction", grocery: true },
  },
  warehouses: {
    title: t("warehouses"),
    icon: "mdi-warehouse",
    component: WarehouseScreenWarehouses,
    filters: {},
  },
});

/** Grupe gornje navigacije (naziv grupe iznad kartica); redosled kartica = prečice 1–9. */
export const buildWarehouseMenu = (t) => [
  {
    key: "procurement",
    title: t("warehouse_shell.groups.procurement"),
    items: ["requirement", "purchase", "offers", "entry"],
  },
  {
    key: "stock",
    title: t("warehouse_shell.groups.stock"),
    items: ["inventory", "list", "invoice", "return", "writeOff"],
  },
  {
    key: "records",
    title: t("warehouse_shell.groups.records"),
    items: ["transaction", "warehouses"],
  },
];
